import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationAPIService } from 'src/app/extensions/services/api/application-api.service';
import { mergeMap } from 'rxjs/operators';
import { isValidGuid } from 'src/app/extensions/utilities';
import { ENV_CONFIG } from '../injection.token';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInterceptor implements HttpInterceptor {
  public constructor(
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData,
    private _applicationAPIService: ApplicationAPIService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isSameOriginUrl(req) || req.url.includes('getApplicationId') || req.url.includes('getTenantId')) {
      return next.handle(req);
    }

    const appId = localStorage.getItem('appId') as string;

    if (appId != null && isValidGuid(appId)) {
      req = req.clone({ headers: req.headers.append('appId', appId) });
      return next.handle(req);
    }

    return this._applicationAPIService
      .GetAppId(this._envConfig.APP_CODE)
      .pipe(mergeMap(newAppId => this.processRequestWithAppId(newAppId, req, next)));
  }

  private processRequestWithAppId(appId: string, req: HttpRequest<any>, next: HttpHandler) {
    localStorage.setItem('appId', appId);
    req = req.clone({ headers: req.headers.append('appId', appId) });
    return next.handle(req);
  }

  private isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }
}
